/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Date } from "./Date";
import type { DateTime } from "./DateTime";
export type PaymentStatus = {
  at: DateTime;
  type: PaymentStatus.type;
  until: Date;
} | {
  at: DateTime;
  type: PaymentStatus.type;
};
export namespace PaymentStatus {
  export enum type {
    PAID = "paid",
  }
}
